import React, { useState, useEffect } from 'react';


import Card from 'react-bootstrap/Card';
import config from '../../config/config';


import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';





const ProjectCardPortrait = ({project}) => {   
    if(project){
        return (
            <Card className="bg-dark text-white featureCard mb-4 half">
                <Card.Img src={`${config.uploadUrl}/uploads/projects/pictures/${project.image}?auto=compress&cs=tinysrgb&w=800&h=750&dpr=2`} alt={project.title} />
                <Card.ImgOverlay>
                    <div className="d-flex align-items-center">
                        <figure className="mb-0 me-3"><img src=""/></figure>
                        <div>
                            <Card.Title>{project.title}</Card.Title>
                            <Card.Text>2,3 BHK Apartment, {project.location}</Card.Text>
                        </div>
                    </div>
                </Card.ImgOverlay>
                <Card.Link href={`/project/${project.slug_url}`} className='flow-btn position-absolute w-100 h-100 top-0 start-0 ms-0'></Card.Link>
            </Card>                                
        )
    } else {
        return null;
    }
}
function mapStateToProps(state) {
    return {
        // relatedProperties: state.property.relatedProperties
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        // getRelatedProperties: (post) => dispatch(actions.getRelatedProperties(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(ProjectCardPortrait);